import { FitmentSearchOptions } from '@unified-commerce/gpc-vue-storefront-search';

const getFitmentSearchParams = (
  skus: string | string[],
  vehicleId?: number | string,
): FitmentSearchOptions => {
  let filters = '';

  if (Array.isArray(skus)) {
    const toAdd = skus.map((sku) => `shopifysku:${sku}`).join(' OR ');
    filters = `(${toAdd})`;
  } else {
    filters = `shopifysku:${skus}`;
  }

  if (vehicleId) {
    filters += ` AND vehicleid:${vehicleId}`;
  }

  return {
    filters,
    resultsPerPage: 100,
  };
};

export default getFitmentSearchParams;
